module.exports = __webpack_public_path__ + "img/KD.680bb7b4.png";